export const jsonStringify = (obj: any, param?: { clearCircular: boolean }) => JSON.stringify(obj, param?.clearCircular ? getCircularReplacer() : undefined);

export const clearCircularFromObject = (obj: any) => JSON.parse(jsonStringify(obj, { clearCircular: true }));

const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key: any, value: any) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return 'Circular ref removed !';
      }
      seen.add(value);
    }
    return value;
  };
};
